module.exports = __webpack_public_path__ + "img/card-show-bg1-btn1.38d5aadd.png";